import App from './app';
// Import style main scss file
import './scss/main.scss';

// Create a new app component and load that to the view
new App({ data: {} }).load();
